"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementFieldTypeToJSON = exports.MeasurementFieldTypeFromJSONTyped = exports.MeasurementFieldTypeFromJSON = exports.MeasurementFieldType = void 0;
/**
 *
 * @export
 */
exports.MeasurementFieldType = {
    SkadTotalInstalls: 'SKAD_TOTAL_INSTALLS',
    SpaaModeledAddToCart: 'SPAA_MODELED_ADD_TO_CART',
    SpaaModeledLead: 'SPAA_MODELED_LEAD',
    SpaaModeledPageView: 'SPAA_MODELED_PAGE_VIEW',
    SpaaModeledPurchase: 'SPAA_MODELED_PURCHASE',
    SpaaUnmodeledAddToCart: 'SPAA_UNMODELED_ADD_TO_CART',
    SpaaUnmodeledLead: 'SPAA_UNMODELED_LEAD',
    SpaaUnmodeledPageView: 'SPAA_UNMODELED_PAGE_VIEW',
    SpaaUnmodeledPurchase: 'SPAA_UNMODELED_PURCHASE',
    KochavaAppInstalls: 'KOCHAVA_APP_INSTALLS',
    AppsflyerAppInstalls: 'APPSFLYER_APP_INSTALLS'
};
function MeasurementFieldTypeFromJSON(json) {
    return MeasurementFieldTypeFromJSONTyped(json, false);
}
exports.MeasurementFieldTypeFromJSON = MeasurementFieldTypeFromJSON;
function MeasurementFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MeasurementFieldTypeFromJSONTyped = MeasurementFieldTypeFromJSONTyped;
function MeasurementFieldTypeToJSON(value) {
    return value;
}
exports.MeasurementFieldTypeToJSON = MeasurementFieldTypeToJSON;
